import { graphql, useStaticQuery } from 'gatsby'

export const getCountriesList = () => {
  const queryResults = useStaticQuery(graphql`
    query Countries {
      allLocation(filter: { type: { eq: "Country" } }) {
        edges {
          node {
            title
          }
        }
      }
    }
  `)
  return queryResults.allLocation.edges
}
